module.exports = __webpack_public_path__ + "img/nlic_gallery1.9c097649.jpg";